import React from 'react';

/* Components */
import FilterChoice from './FilterChoice';
import FilterOpenInputRange from './FilterOpenInputRange';
import FilterRangeList from './FilterRangeList';

export default function Filter({ id, path, filters, className = '' }) {
    return (
        <div className={(`filter ${className}`).trim()}>
            <div className="row gutters-1">
                {filters.map((filter) => {
                    const filterIndex = filters.indexOf(filter);
                    const filterPath = `${path}.filters.${filterIndex}`;

                    if (filter.viewType === 'select') {
                        return (
                            <div key={filterPath} className="col-12">
                                <FilterChoice
                                    id={`${id}.filters.${filterIndex}`}
                                    path={filterPath}
                                    filter={filter}
                                    multiple={false}
                                />
                            </div>
                        );
                    }

                    if (filter.viewType === 'multi_select') {
                        return (
                            <div key={filterPath} className="col-12">
                                <FilterChoice
                                    id={`${id}.filters.${filterIndex}`}
                                    path={filterPath}
                                    filter={filter}
                                    multiple={true}
                                />
                            </div>
                        );
                    }

                    if (filter.viewType === 'open_input_range_list') {
                        return (
                            <div key={filterPath} className="col-12">
                                <FilterOpenInputRange
                                    id={`${id}.filters.${filterIndex}`}
                                    path={filterPath}
                                    filter={filter}
                                />
                            </div>
                        );
                    }

                    if (filter.viewType === 'range_list') {
                        return (
                            <div key={filterPath} className="col-12">
                                <FilterRangeList
                                    id={`${id}.filters.${filterIndex}`}
                                    path={filterPath}
                                    filter={filter}
                                />
                            </div>
                        );
                    }
                })}
            </div>
        </div>
    );
}
